<template>
    <div class="home">
        <el-affix>
            <TopView></TopView>
        </el-affix>
        <TopBg></TopBg>
        <el-row>
            <el-col :span="4">
                <LineNote
                      :editable="false"
                      :title="'繁星·春水'"
                    >
                        幽兰！未免太寂寞了，不愿意要友伴么？”“我正寻求着呢？但没有别的花，肯开在空谷里。
                    </LineNote>
            </el-col>
            <el-col :span="16">
                <div class="Container">
                    <ListView></ListView>
                </div>
            </el-col>
            <el-col :span="4"></el-col>
        </el-row>
        <el-backtop :right="100" :bottom="100"/>
        <FooterView></FooterView>
    </div>
</template>

<script>
// @ is an alias to /src
import TopView from './TopView.vue';
import TopBg from "@/components/TopBg";
import FooterView from "@/views/FooterView.vue";
import ListView from "@/views/ListView.vue";
import LineNote from "@/components/LineNote/LineNote.vue";


export default {
    name: 'HomeView',
    components: {
        LineNote,
        ListView,
        TopView,
        TopBg,
        FooterView
    },

}
</script>

<style lang="scss" scoped>
.Container {
  //margin-top: 20px;
  //display: flex;
  //flex-direction: column;
  //justify-content: center;
  //align-items: center;
  min-height: 500px;

  //后加的
  margin: 20px 20px 0 20px;
}

</style>
